module.exports = file => () => import('@/components/' + process.env.CHANNEL_PLAT + '/' + file + '.vue')


// WEBPACK FOOTER //
// ./src/router/_import_components.js